import { Modal } from '@mantine/core'
import { PropsWithChildren } from 'react'
import { FormattedMessage } from 'react-intl'

type CreateDatasetModalProps = PropsWithChildren<{
  opened: boolean
  onClose: () => void
}>

export const CreateDatasetModal = ({
  opened,
  onClose,
  children
}: CreateDatasetModalProps) => {
  return (
    <Modal
      size="xl"
      opened={opened}
      title={<FormattedMessage id="datasets.create" />}
      onClose={onClose}
    >
      {children}
    </Modal>
  )
}
